import React, { useContext } from "react";
import { MediaContext } from "./media-context";
import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import { find, includes, prop } from "ramda";
import { useIsAdmin } from "../../auth/authUtils";
import { anyTrue, isBlank } from "../../util/ext";
import { Link } from "react-router-dom";
import { useOrganizationProfile } from "../../manage-organizations/organizationServices";
import { Skeleton } from "@material-ui/lab";
import FontAwesomeIcon from "../../components/FontAwesomeIcon";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons";

const findAllPermission = accessPermissions =>
  prop(
    "principal",
    find(p => includes("ALL", p.permissionList), accessPermissions),
  );

const ContentGroupOwner = () => {
  const { media } = useContext(MediaContext);
  const isAdmin = useIsAdmin();

  const getOwner = () => {
    switch (media.mediaType) {
      case "module":
        return findAllPermission(media.accessPermissions);
      case "anthology":
      case "collection":
        return (
          media?.owningOrganization ??
          findAllPermission(media.accessPermissions)
        );
      default:
        return null;
    }
  };

  const owner = getOwner();
  const org = useOrganizationProfile(owner);

  if (anyTrue([!isAdmin, isBlank(media), isBlank(owner), org.isError])) {
    return null;
  }

  if (org.isLoading) {
    return <Skeleton variant="text" />;
  }

  return (
    <TextField
      id={`organization-that-created-${media.id}`}
      fullWidth
      disabled
      label="Owning Organization"
      value={org?.data?.name ?? owner}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={`Go to org`}
              component={Link}
              to={`/manage-organizations/organizations/${owner}`}
              target="_blank"
            >
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default ContentGroupOwner;
